export default {"src":"/_next/static/media/icon-flow.f2c19077.svg","height":1600,"width":1600};